export const getSitemapData = `
  query GetSitemapData(
  $locale: SiteLocale 
  $first: IntType
  ) {
    allProducts(locale: $locale, first: $first) {
      id
      slug
      _allSlugLocales {
        value
        locale
      }
    }
  }
`
